import React, {useEffect, useRef} from 'react';
import './Drawer.less';
import {DrawerChevron} from "elements/drawer-chevron/DrawerChevron";
import ScrollHelper from "helpers/scroll.helper";
import {LoadingSpinner} from "../../elements/loading-spinner/LoadingSpinner.tsx";
import {InlineSpinner} from "../../elements/inline-spinner/InlineSpinner";

export const Drawer = ({topStaticControl, children, bottomStaticControl, isShowChevron = true, isLoading = false, onChevronClick}) => {
	const containerElement = useRef(null);

	useEffect(() => {
		const scroll = ScrollHelper.initIScroll(containerElement.current, {
			scrollX: false,
			scrollY: true,
			scrollbars: true
		});

		return () => {
			scroll && scroll.destroy();
		};
	}, []);

	return <div className="drawer">
		{
			isShowChevron && (<div
				className="drawer__icon"
				onClick={onChevronClick}
			>
				<DrawerChevron/>
			</div>)
		}
		{
			topStaticControl && (
				<div className="drawer__top-static-control">
					{topStaticControl}
				</div>
			)
		}
		<div className="drawer__contents" ref={containerElement}>
			<div className="drawer__container">
				{children}
			</div>
		</div>
		{
			bottomStaticControl && (<div className="drawer__bottom-static-control">
				{bottomStaticControl}
			</div>)
		}
		{
			isLoading && <div className="drawer__loading">
				<div className="drawer__loading-spinner">
					<InlineSpinner/>
				</div>
			</div>
		}
	</div>
}
